export class TravisBookingForm {

  constructor(public parkingId: string,
              public startDate: string,
              public endDate: string,
              public driverName: string,
              public driverLang: string,
              public locationZone: string,
              public taskId: number,
              public vehicleId: number,
              public licensePlate: string,
              public trailerLicensePlate: string) {
  }

}
